export default "__VITE_ASSET__C0bN6vAK__"